<template>
	<v-card :elevation="elevation" class="calender-component" height="100%">
		<v-app-bar :class="showAppBar ? 'color-white' : ''" tag="div" dense flat :color="showAppBar ? 'primary' : 'white'">
			<v-app-bar-title> {{ title }} </v-app-bar-title>
			<v-spacer />
			<v-menu bottom right>
				<template v-slot:activator="{ on, attrs }">
					<v-btn small outlined :color="showAppBar ? 'white' : 'primary'" v-bind="attrs" v-on="on">
						<span>{{ typeToLabel[type] }}</span>
						<v-icon right> mdi-menu-down </v-icon>
					</v-btn>
				</template>
				<v-list>
					<v-list-item @click="type = 'day'">
						<v-list-item-title>日</v-list-item-title>
					</v-list-item>
					<v-list-item @click="type = 'week'">
						<v-list-item-title>週</v-list-item-title>
					</v-list-item>
					<v-list-item @click="type = 'month'">
						<v-list-item-title>月</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
			<v-btn icon text :color="showAppBar ? 'white' : 'primary'" @click="prev">
				<v-icon> mdi-chevron-left </v-icon>
			</v-btn>
			<v-btn icon text :color="showAppBar ? 'white' : 'primary'" @click="next">
				<v-icon> mdi-chevron-right </v-icon>
			</v-btn>
		</v-app-bar>
		<v-sheet elevation="0" :height="height" class="overflow-y-auto">
			<v-calendar
				ref="calendar"
				locale="ja-JP"
				v-model="focus"
				color="secondary"
				:events="events"
				:event-color="getEventColor"
				:type="type"
				:first-time="firstTime"
				:interval-count="intervalCount"
				interval-width="40"
				interval-height="36"
				:weekdays="[1, 2, 3, 4, 5, 6, 0]"
				:event-more-text="'確認する'"
				@click:more="viewDay"
				@click:date="viewDay"
				@click:event="clickEvent"
				@change="updateRange"
			/>
			<!-- @click:date="type != 'day' ? (type = 'week') : (type = 'day')" -->
		</v-sheet>
	</v-card>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	props: {
		title: { type: String, required: false, default: null },
		height: { type: Number, required: false, default: 200 },
		events: {
			type: Array,
			required: true,
			default: () => ({
				name: String,
				start: String,
				end: String,
				color: String,
				timed: Boolean,
			}),
		},
		showAppBar: {
			type: Boolean,
			default: true,
			required: false,
		},
    elevation:{
      type: Number,
      default: 5,
      required: false,
    },
	},
	data() {
		return {
			focus: "",
			type: "week",
			typeToLabel: {
				month: "月",
				week: "週",
				day: "日",
			},
			firstTime: "00:00",
			colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"],
			names: ["Meeting", "Holiday", "PTO", "Travel", "Event", "Birthday", "Conference", "Party"],
		}
	},
	methods: {
		viewDay({ date }) {
			this.focus = date
			this.type == "day" ? (this.type = "week") : (this.type = "day")
		},
		getEventColor(event) {
			return event.color
		},
		prev() {
			this.$refs.calendar.prev()
		},
		next() {
			this.$refs.calendar.next()
		},
		clickEvent(e) {
			this.$emit("click-event", e)
		},
		updateRange({ start, end }) {
			const events = this.events.filter((e) => start.date > e.start && end.date < e.end)
			const sortedEvents = events.sort((a, b) => {
				if (a.start > b.start) {
					return -1
				} else if (a.start < b.start) {
					return 1
				} else {
					return 0
				}
			})
			if (sortedEvents[0]) {
				this.firstTime = moment(sortedEvents[0].start).format("hh:00")
			} else {
				this.firstTime = "09:00"
			}
		},
	},
	computed: {
		intervalCount() {
			const totalHours = 24
			if (!this.firstTime) return totalHours
			const hour = this.firstTime.split(":")[0]
			return totalHours - Number(hour)
		},
	},
}
</script>

<style lang="scss">
.calender-component {

	.v-btn--fab.v-size--default {
		width: 40px;
		height: 40px;
	}
}
</style>